import { useMemo } from 'react';

import {
  DEFAULT_SCREEN_OPTIONS,
  type ScreenOptionsMap,
} from '../../../../constants';
import { useRouteTitles } from '../../../messages';

/**
 * Screen options for the reorder tab layout.
 */
export const useReorderTabStackOptions = () => {
  const titles = useRouteTitles();

  return useMemo(() => {
    return {
      //
      // ─── Main Stack Options (applied to all screens) ─────────────────────

      Stack: DEFAULT_SCREEN_OPTIONS,

      // ─── Individual Tabs ─────────────────────────────────────────────────

      Home: { title: titles.reorderTitle },
    } satisfies ScreenOptionsMap;
  }, [titles]);
};
